import React, { Fragment, FC } from 'react';

import theme from '@adsk/alloy-react-theme';

import { LicenseDataType } from '../helpers/types';
import Line from './Line';

type ManualAboutBoxContentProps = {
  data?: LicenseDataType;
};

const ManualAboutBoxContent: FC<ManualAboutBoxContentProps> = ({ data }) => {
  return (
    <>
      {data &&
        data.features.map((feature) => (
          <Fragment key={feature.title}>
            <Line style={{ ...theme.typography.heading4, marginTop: 20 }}>
              {feature.title}
            </Line>
            {feature.licenses.map((license, i) => (
              // Some licenses are duplicated until an automated process can smooth these out
              <Fragment key={feature.title + i}>
                <Line>{license.type}</Line>
                {license.libraries.map((library) => (
                  <Fragment key={feature.title + library.library}>
                    <Line style={theme.typography.labelMedium}>
                      {library.library}
                    </Line>
                    <Line
                      style={{ ...theme.typography.labelSmall, marginTop: 0 }}
                    >
                      {library.copyright}
                    </Line>
                  </Fragment>
                ))}
                <Line>{license.description}</Line>
              </Fragment>
            ))}
          </Fragment>
        ))}
    </>
  );
};

export default ManualAboutBoxContent;
